import React from 'react';
import Heading from '../../../generic-components/Heading';
import { refactoredTimeAndDate } from '../../../helpers/timeFormatter.helper';
import { STYLES } from '../constants';
import { DATE_FORMAT } from '../../../constants/general';

const {
  STEP: {
    CONTENT_WRAPPER, HEADING, INNER_CONTENT_WRAPPER, REGULAR_CONTENT, BOLDED_CONTENT,
  },
} = STYLES;

interface IProps {
    title: string;
    content: string;
    isActive: boolean;
    isLastStep: boolean;
    shippingDate?: Date | null;
}
export const Step = ({
  title, content, isActive, isLastStep, shippingDate,
}: IProps) => (
  <div className={`relative ${isLastStep ? '' : 'border-l-[1px] border-l-bw03'} pl-[24px] ${isLastStep ? '' : 'pb-[34px]'}`}>
    <div data-testid={`card-tracker-step__card-status__dot__${title?.toLowerCase()}`} className={`${isActive ? 'animate-activeTrackerBlink' : ' '} absolute left-0 top-0 translate-x-[-50%] mr-[16px] w-[15px] min-w-[15px] h-[15px] rounded-[50%] ${isActive ? 'bg-action03' : 'bg-bw03'}`} />
    <div className={CONTENT_WRAPPER}>
      <Heading title={title} className={HEADING} />
      {isActive && (
        <div data-testid={`card-tracker-step__card-status__text__${title?.toLowerCase()}`} className={INNER_CONTENT_WRAPPER}>
          <p className={REGULAR_CONTENT}>
            {content}
            {shippingDate && (
            <span className={BOLDED_CONTENT}>
              {' '}
              {refactoredTimeAndDate(shippingDate.toString(), 'CardTrackerStep', DATE_FORMAT.LETTERS_FULL, false)}
            </span>
            )}
          </p>

        </div>
      )}
    </div>
  </div>
);
